// Shared row styling for the "Premium Glass" list pages. Returns an sx
// fragment that gives a table row: a status-coloured accent bar on the left
// edge (revealed on hover), a subtle hover lift, and a staggered fade-in-up
// entrance animation as the list paints.
//
// Usage inside a row's sx:
//   sx={{ ...glassRowSx({ idx, accent: style.gradient, hoverBg: colors.hover }), ...rest }}
//
// Params:
//   idx     — row index in the current page (drives the stagger delay)
//   accent  — gradient/colour for the left accent bar (omit for none)
//   hoverBg — background applied on hover (usually colors.hover)
export function glassRowSx({ idx = 0, accent, hoverBg } = {}) {
  return {
    position: "relative",
    ...(accent && {
      "&::before": {
        content: '""',
        position: "absolute",
        left: 0,
        top: 0,
        bottom: 0,
        width: "3px",
        background: accent,
        opacity: 0,
        transition: "opacity 0.2s ease",
      },
      "&:hover::before": { opacity: 1 },
    }),
    "&:hover": {
      ...(hoverBg && { background: hoverBg }),
      transform: "translateX(3px)",
    },
    transition: "background 0.18s ease, transform 0.18s ease",
    opacity: 0,
    animation: "glassRowIn 0.4s ease forwards",
    animationDelay: `${Math.min(idx, 12) * 0.035}s`,
    "@keyframes glassRowIn": {
      from: { opacity: 0, transform: "translateY(8px)" },
      to: { opacity: 1, transform: "translateY(0)" },
    },
  };
}
